import type { PropsWithChildren } from "react";

interface LegalDocumentProps extends PropsWithChildren {
  description: string;
  title: string;
  updated: string;
}

// Give product policies one accessible, readable structure while allowing each
// site to supply its own legal language and surrounding navigation.
//
export function LegalDocument({
  children,
  description,
  title,
  updated,
}: LegalDocumentProps) {
  return (
    <article>
      <header className="border-b pb-8">
        <p className="text-muted-foreground text-xs font-semibold tracking-[0.14em] uppercase">
          Effective {updated}
        </p>
        <h1 className="mt-3 text-4xl font-semibold tracking-[-0.04em] sm:text-5xl">
          {title}
        </h1>
        <p className="text-muted-foreground mt-5 max-w-2xl text-lg leading-8">
          {description}
        </p>
      </header>

      <div className="text-muted-foreground [&_a]:underline-decoration [&_a]:text-foreground [&_h2]:text-foreground [&_h3]:text-foreground mt-10 space-y-10 leading-7 [&_a]:underline [&_h2]:mb-3 [&_h2]:text-2xl [&_h2]:font-semibold [&_h2]:tracking-[-0.025em] [&_h3]:mt-5 [&_h3]:mb-2 [&_h3]:text-lg [&_h3]:font-semibold [&_li]:ml-5 [&_li]:list-disc [&_p+p]:mt-3 [&_ul]:mt-3 [&_ul]:space-y-2">
        {children}
      </div>
    </article>
  );
}
